import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class TechDomainService {
  public selectedDomainId = new BehaviorSubject<any>({});

  currentselectedDomainId = this.selectedDomainId.asObservable();

constructor() {
  if (window.localStorage.getItem('selectedTechDomainId')) {
    this.setCurrentSelectedIds(window.localStorage.getItem('selectedTechDomainId'));
  } else {
    this.setCurrentSelectedIds(null);
  }
 }

 setCurrentSelectedIds(value: any) {
   if (value) {
    localStorage.setItem('selectedTechDomainId', value);
    this.selectedDomainId.next(value);
   } else {
    localStorage.removeItem('selectedTechDomainId');
    this.selectedDomainId.next(value);
   }
 }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/tech-domain.service.ts